import {
  Classification,
  ClassificationGroup,
  ClassificationLevel,
} from '@core/generated/gql-types';

export interface ClassificationCard {
  id: string;
  classificationGroup: ClassificationGroup;
  classification: Classification;
  classificationLevel?: ClassificationLevel;
}

export interface ModalState {
  classificationGroup: ClassificationGroup | undefined;
  classification: Classification | undefined;
  classificationLevel: ClassificationLevel | undefined;
}

export const emptyModalState: ModalState = {
  classificationGroup: undefined,
  classification: undefined,
  classificationLevel: undefined,
};
